import { firebase_analytics } from '../firebase/firebaseConfig';
import { logEvent } from 'firebase/analytics';

// Función para registrar eventos de página
export const trackPageView = (pageName) => {
  try {
    logEvent(firebase_analytics, 'page_view', {
      page_title: pageName,
      page_location: window.location.href,
      page_path: window.location.pathname
    });
    console.log(`Página registrada en Analytics: ${pageName}`);
  } catch (error) {
    console.error('Error al registrar vista de página:', error);
  }
};

// Función para registrar eventos personalizados
export const trackEvent = (eventName, eventParams = {}) => {
  try {
    logEvent(firebase_analytics, eventName, eventParams);
    console.log(`Evento registrado en Analytics: ${eventName}`, eventParams);
  } catch (error) {
    console.error(`Error al registrar evento ${eventName}:`, error);
  }
};

// Ejemplos de eventos predefinidos
export const trackReservation = (reservationData) => {
  trackEvent('create_reservation', {
    reservation_id: reservationData.id,
    check_in_date: reservationData.checkInDate,
    check_out_date: reservationData.checkOutDate,
    room_type: reservationData.roomType,
    guests: reservationData.numGuests
  });
};

export const trackLogin = (userId, method = 'email') => {
  trackEvent('login', {
    method: method,
    user_id: userId
  });
}; 